import { inject, Injectable } from '@angular/core';
import { InsightsFilters } from '@app/types/insights-filters';
import { ApiService } from '../api/api.service';
import { InsightsModel } from '@app/models/insights/insights.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InsightsService {
  private readonly apiService = inject(ApiService);

  getInsights(filters: InsightsFilters): Observable<InsightsModel> {
    const resourceUrl = 'insights';

    return this.apiService.post<InsightsModel>(resourceUrl, JSON.stringify(filters), void 0, 'GetInsights');
  }
}
